import React from "react";
import { Loader2 } from "lucide-react";

const Button = ({
  children,
  variant = "primary", // primary, secondary, outline, danger, ghost
  size = "md", // sm, md, lg
  isLoading = false,
  className = "",
  disabled,
  ...props
}) => {
  const baseStyles =
    "inline-flex items-center justify-center rounded-xl font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.98]";

  const variants = {
    primary:
      "bg-primary-600 text-white hover:shadow-lg hover:shadow-primary-500/30 border border-transparent",
    secondary:
      "bg-white/50 backdrop-blur-sm text-gray-700 hover:bg-white/80 border border-gray-200 shadow-sm",
    outline:
      "border-2 border-primary-500 text-primary-600 hover:bg-primary-50",
    danger: "bg-red-500 text-white hover:bg-red-600 shadow-sm",
    ghost: "text-gray-600 hover:bg-gray-100/50 hover:text-gray-900",
  };

  const sizes = {
    sm: "px-3 py-1.5 text-xs",
    md: "px-4 py-2 text-sm",
    lg: "px-6 py-3 text-base",
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </button>
  );
};

export default Button;
